import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  allSiteIntelligenceServices,
  keywordLabel,
  KeywordType,
  SiService,
  SiteIntelligenceService,
  siteIntelligenceServiceLabel,
  SiteService,
} from '../../../pages/siteIntelligence/mappings';
import clsx from 'clsx';

interface Props {
  type: KeywordType | SiService;
  isAbbreviated?: boolean;
  className?: string;
}

export function getKeywordTypeColor(type: KeywordType | SiService) {
  let color = '';
  let fontColor: 'light' | 'dark' = 'light';
  switch (type) {
    case SiService.ADULT_SHIELD_SERVICE:
      color = '#d41e54';
      break;
    case SiService.TOBACCO_SIFT_SERVICE:
      color = '#d49667';
      break;
    case SiService.MEMBERS_ONLY_SIFT_SERVICE:
      color = '#9400D3';
      break;
    case KeywordType.ADULT: // TODO: combine with ADULT_SHIELD_SERVICE later for production
      color = '#CE3042';
      break;
    case KeywordType.ALCOHOL:
      color = '#008B8B';
      break;
    case KeywordType.CASINO:
      color = '#0B6623';
      break;
    case KeywordType.CHARITY:
      color = '#BDB76B';
      break;
    case KeywordType.CRYPTOCURRENCY:
      color = '#F7931A';
      break;
    case KeywordType.DATING:
      color = '#F1B3D7';
      fontColor = 'dark';
      break;
    case KeywordType.FINANCIAL:
      color = '#2E8B57';
      break;
    case KeywordType.GAMING:
      color = '#00008B';
      break;
    case KeywordType.HEALTH:
      color = '#FF8C00';
      break;
    case KeywordType.IPTV:
      color = '#483D8B';
      break;
    case KeywordType.LIVE_STREAM:
      color = '#C71585';
      break;
    case KeywordType.VOUCHER:
      color = '#B8860B';
      break;
    case KeywordType.VPN:
      color = '#1E90FF';
      break;
    case KeywordType.WEAPON:
      color = '#2F4F4F';
      break;
    case KeywordType.FIREWORK:
      color = '#E04939';
      break;
    case KeywordType.SPORT_JERSEYS:
      color = '#FF4500';
      break;
    case KeywordType.E_BOOK:
      color = '#6A5ACD';
      break;
    // case KeywordType.MOVIE:
    //   color = '#8B008B';
    //   break;
    // case KeywordType.VIDEO:
    //   color = '#DC143C';
    //   break;
    // case KeywordType.MUSIC:
    //   color = '#20B2AA';
    //   break;
    case KeywordType.DUMMY:
      color = '#D3D3D3';
      fontColor = 'dark';
      break;
    // case KeywordType.BLOG:
    //   color = '#556B2F';
    //   break;
    // case KeywordType.FORUM:
    //   color = '#4682B4';
    //   break;
    // case KeywordType.NEWS:
    //   color = '#66DF33';
    //   fontColor = 'dark';
    //   break;
    case KeywordType.CMS:
      color = '#FFED3F';
      fontColor = 'dark';
      break;
    case KeywordType.PHARMACY:
      color = '#4B0082';
      break;
    case KeywordType.MEDICAL_DEVICE_AND_ACCESSORY:
      color = '#2F80ED';
      break;
    case KeywordType.GAME_ASSET:
      color = '#FF7A00';
      break;
    case KeywordType.AI_GENERATED_MEDIA:
      color = '#5A67D8';
      break;
    case KeywordType.CELEBRITY:
      color = '#E11D48';
      break;
    case KeywordType.INVALID_SITE_TITLE:
      color = '#8B0000';
      break;
    default:
      color = '#808080';
      break;
  }
  return { color, fontColor };
}

export default function KeywordTypeBadge({ type, isAbbreviated = false, className }: Props) {
  const colors = getKeywordTypeColor(type);
  const longLabel = siteIntelligenceServiceLabel[type] ?? keywordLabel[type] ?? type;
  const label = isAbbreviated
    ? type
      .replace(/[^a-zA-Z]/g, '')
      .slice(0, 2)
      .toUpperCase()
    : longLabel;

  const renderBadge = () => {
    return (
      <div
        className={clsx(`badge fw-bold text-${colors.fontColor} text-wrap lh-sm`, className)}
        style={{
          backgroundColor: colors.color,
        }}
      >
        {label}
      </div>
    );
  };

  return isAbbreviated ? (
    <OverlayTrigger placement='top' overlay={<Tooltip>{longLabel}</Tooltip>}>
      {renderBadge()}
    </OverlayTrigger>
  ) : (
    renderBadge()
  );
}
